module.exports = __webpack_public_path__ + "static/media/docx.77951f5c.png";